"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class EmptyResult {
    constructor(name) {
        this.id = "empty";
        this.name = name;
        this.displayName = name;
        this.city = "";
        this.country_long_name = "";
        this.country_short_name = "";
        this.latitude = -1;
        this.longitude = -1;
        this.postal_code = "";
        this.state_long_name = "";
        this.state_short_name = "";
        this.label = "";
        this.value = "";
    }
}
exports.default = EmptyResult;
